import { snackbar } from '@flipster/react/design-system/snackbar/index';
import { alert } from '@flipster/ui/Alert';
import { canSendNativeRequest, sendNativeRequest } from '@flipster/utils/simple-bridge/bridge';

// 시간 없어서 떔빵으로 만드는 wrapper. 추후 고도화 필요
export const showAlert = ({
  title,
  content,
  confirmText,
  closeText,
}: {
  title: string;
  content: string;
  confirmText: string;
  closeText?: string;
}) => {
  if (canSendNativeRequest) {
    sendNativeRequest({
      name: 'showAlert',
      callback: 'onShowAlertResult',
      params: {
        title,
        content,
        positive_button: confirmText,
        negative_button: closeText ?? null,
      },
    });
  } else {
    alert.show({
      title,
      message: <div style={{ whiteSpace: 'pre-wrap' }}>{content}</div>,
      confirmText,
      closeText,
    });
  }
};

export const showSnackbar = ({
  message,
  type = 'success',
}: {
  message: string;
  type?: 'success' | 'warning' | 'error';
  buttonText?: string;
  buttonPage?: string;
}) => {
  if (canSendNativeRequest) {
    sendNativeRequest({
      name: 'showSnackbar',
      callback: 'onShowSnackbarResult',
      params: {
        icon: type.toUpperCase() as 'SUCCESS' | 'WARNING' | 'ERROR',
        message,
        button: null,
      },
    });
  } else {
    snackbar[type]({
      message,
    });
  }
};
